class MobileAnalyticsTracker {
    /**
     * Track mobile analytics data
     * @param {Object} payload - The analytics payload containing type and data
     * @returns {Promise<void>}
     */
    static async track(payload) {
        if (!payload || typeof payload !== "object") {
            console.warn("MobileAnalyticsTracker: Invalid payload provided");
            return;
        }

        try {
            await axios.post("/analytics/logs", payload);
        } catch (error) {
            console.error("Error tracking mobile analytics:", error);
        }
    }
}

export default MobileAnalyticsTracker;
